"use strict";

import {loadImg} from "../libs/@elements/lazy-img";

export function initInScope ($scope) {
    let $sliders = $scope.find('.js-slider');
    let $townSliderRd = $scope.find('.js-town-slider-rd');
    let $dynamicSliders = $scope.find('.js-dynamic-slider');
    let $dynamicSlidersFixedW = $scope.find('.js-dynamic-slider-fixedw');
    let $quoteSlider = $scope.find('.js-quote-slider');
    let $teaserSlider = $scope.find('.js-teaser-slider');
    let $townSlider = $scope.find('.js-teaser-slider--towns');
    let $fancyTeaserSlider = $scope.find('.js-fancy-teaser-slider');

    import('slick-carousel').then(function() {
        $sliders.slick({
            dots: true, /*should always be true; hide with css (accessibility)*/
            slidesToShow: 1,
            swipeToSlide: true,
            infinite: false,
            prevArrow:"<button type='button' class='slick-prev' aria-label='prev'><i class='icon icon-button-arrow'></i></button>",
            nextArrow:"<button type='button' class='slick-next' aria-label='next'><i class='icon icon-button-arrow'></i></button>",
        });

        if($townSliderRd.length > 0) {
            $townSliderRd.each(function () {
                $(this).slick({
                    dots: true, /*should always be true; hide with css (accessibility)*/
                    arrows: false,
                    slidesToShow: 0,
                    // variableWidth: true,
                    swipeToSlide: true,
                    draggable: true,
                    infinite: false
                });
            });
        }
        if($dynamicSlidersFixedW.length > 0) {
            function initDynamicSliderFixedW(scope, outerSlideWidth) {
                var slidesToShow = null;
                // if($(this).data("slides-to-show") == "zero") {
                //     var slidesToShow = 0;
                // }



                var sliderWidth = scope.width();
                // console.log("sliderWidth");
                // console.log(sliderWidth);
                // console.log("sliderOuterWidth");
                // console.log(scope.outerWidth());
                var slides = scope.find(".slick-slide");
                // var outerSlideWidth = scope.find(".slick-slide:first").outerWidth();
                slidesToShow = Math.floor((sliderWidth / outerSlideWidth) * 100) / 100;
                // console.log("outerSlideWidth");
                // console.log(outerSlideWidth);

                // console.log(slidesToShow);
                scope.addClass("slider--same-height-teasers");
                scope.slick({
                    dots: true, /*should always be true; hide with css (accessibility)*/
                    arrows: false,
                    slidesToShow: slidesToShow,
                    // variableWidth: true,
                    swipeToSlide: slides.length > slidesToShow,
                    draggable: slides.length > slidesToShow,
                    infinite: false
                });
            }
            function getSlickTeaserWidth(el) {
                var marginLeft = parseInt(el.css('margin-left')); // Get the left margin
                var marginRight = parseInt(el.css('margin-right'));
                var initOuterSlideWidth = el.outerWidth() + marginLeft + marginRight;
                return initOuterSlideWidth;
            }
            $dynamicSlidersFixedW.each(function () {
                var element = $(this);
                var sliderEl = element.find(".teaser:first");
                var initOuterSlideWidth = getSlickTeaserWidth(sliderEl);

                initDynamicSliderFixedW($(this), initOuterSlideWidth);
                $(window).on('resize', function() {
                    // console.log("resize dynamic  slider FIXEDW");
                    if (element.hasClass('slick-initialized')) {
                        element.slick('unslick'); // This destroys the current slider instance
                    }
                    if(element.data("init-show-slides")) {
                        element.addClass('init-show-slides');
                    }

                    var sliderEl = element.find(".teaser:first");
                    var initOuterSlideWidth = getSlickTeaserWidth(sliderEl);
                    initDynamicSliderFixedW(element, initOuterSlideWidth);
                });
            });
        }
        if($dynamicSliders.length > 0) {

            function initDynamicSlider(scope, initialSlides) {
                var sliderWidth = scope.width();
                var sliderWitdhCurr = sliderWidth;
                var realSlidesBag = [];
                var realSlidesCurrent = [];

                function addRealSlide(realSlidesCurrent) {
                    var newSlide = $('<div class="slick-slide text-center"></div>');
                    for (let i = 0; i < realSlidesCurrent.length; i++) {
                        newSlide.append(realSlidesCurrent[i]);
                    }
                    realSlidesBag.push(newSlide);
                }
                //calculate and adjust the slides and put them inside one slide, so no partial slides are shown

                for (let i = 0; i < initialSlides.length; i++) {
                    sliderWitdhCurr -= initialSlides[i].initWidth;
                    if(sliderWitdhCurr >= 0) {
                        realSlidesCurrent.push(initialSlides[i].element);
                    } else {
                        addRealSlide(realSlidesCurrent);
                        realSlidesCurrent = [];
                        realSlidesCurrent.push(initialSlides[i].element);
                        sliderWitdhCurr = sliderWidth;
                        sliderWitdhCurr -= initialSlides[i].initWidth;
                    }
                }
                addRealSlide(realSlidesCurrent);

                scope.empty();
                for (let i = 0; i < realSlidesBag.length; i++) {
                    scope.append(realSlidesBag[i]);
                }
                var draggable = true;
                if(realSlidesBag.length <= 1) {
                    draggable = false;
                    // console.log("returning no slider needed");
                    return; //no slider needed
                }
                if(scope.hasClass('init-show-slides')) {
                    scope.data("init-show-slides", true);
                    scope.removeClass('init-show-slides');
                }

                scope.slick({
                    dots: true, /*should always be true; hide with css (accessibility)*/
                    arrows: false,
                    slidesToShow: 1,
                    // variableWidth: true,
                    swipeToSlide: draggable,
                    draggable: draggable,
                    infinite: false
                });

            }
            $dynamicSliders.each(function () {
                // console.time("dynamic");
                var element = $(this);
                var initialSlides = [];
                $(this).find('.slick-slide').each(function() {
                    initialSlides.push({
                        initWidth: $(this).outerWidth(),
                        element: $(this).find(".dynamic-slick-inner")
                    });
                });
                // console.log("initialSlides");
                // console.log(initialSlides);
                initDynamicSlider(element, initialSlides);
                $(window).on('resize', function() {
                    // console.log("resize dynamic  slider");
                    if (element.hasClass('slick-initialized')) {
                        element.slick('unslick'); // This destroys the current slider instance
                    }
                    if(element.data("init-show-slides")) {
                        element.addClass('init-show-slides');
                    }
                    for (var i = 0; i < initialSlides.length; i++) {
                        initialSlides[i].initWidth = initialSlides[i].element.outerWidth();
                    }
                    initDynamicSlider(element, initialSlides);
                });
                // console.timeEnd("dynamic");
            });

        }


        $fancyTeaserSlider.each(function() {
            $(this).slick({
                dots:true,
                slidesToShow: 1.375,
                centerMode: true,
                centerPadding:'0',
                swipeToSlide: true,
                infinite: false,
                prevArrow:"<button type='button' class='slick-prev' aria-label='prev'><i class='icon icon-button-arrow'></i></button>",
                nextArrow:"<button type='button' class='slick-next' aria-label='next'><i class='icon icon-button-arrow'></i></button>",
                appendArrows: $(this).closest('.js-fancy-teaser-arrows-wrap').find('.js-fancy-teaser-arrow-holder'),
            })
        });


        $quoteSlider.each(function() {
            $(this).slick({
                dots:true,
                slidesToShow: 1,
                swipeToSlide: true,
                infinite: false,
                prevArrow:"<button type='button' class='slick-prev' aria-label='prev'><i class='icon icon-button-arrow'></i></button>",
                nextArrow:"<button type='button' class='slick-next' aria-label='next'><i class='icon icon-button-arrow'></i></button>",
                appendArrows: $(this).closest('.js-quote-arrows-wrap').find('.js-quote-arrow-holder'),
            })
        });


        $teaserSlider.each(function() {
            $(this).slick({
                dots:true,
                slidesToShow: 3.75,
                swipeToSlide: true,
                infinite: false,
                prevArrow:"<button type='button' class='slick-prev' aria-label='prev'><i class='icon icon-button-arrow'></i></button>",
                nextArrow:"<button type='button' class='slick-next' aria-label='next'><i class='icon icon-button-arrow'></i></button>",
                appendArrows: $(this).closest('.js-teaser-arrows-wrap').find('.js-teaser-arrow-holder'),
                responsive: [
                    {
                        breakpoint: 1400,
                        settings: {
                            slidesToShow: 2.75
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1.25,
                            slidesToScroll: 1
                        }
                    }]
            })
        });


        $townSlider.each(function() {
            $(this).slick({
                dots:true,
                slidesToShow: 5.75,
                swipeToSlide: true,
                infinite: false,
                prevArrow:"<button type='button' class='slick-prev' aria-label='prev'><i class='icon icon-button-arrow'></i></button>",
                nextArrow:"<button type='button' class='slick-next' aria-label='next'><i class='icon icon-button-arrow'></i></button>",
                appendArrows: $(this).closest('.js-teaser-arrows-wrap').find('.js-teaser-arrow-holder'),
                responsive: [
                    {
                        breakpoint: 1400,
                        settings: {
                            slidesToShow: 4.75
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2.25
                        }
                    }]
            })
        });
    });
}

export function preloadSlide(slick, slideIndex) {
    let slideToPreload = slick.$slides[slideIndex];

    if (slideToPreload) {
        let $imgToPreload = $(slideToPreload).find('.js-lazy-img');
        if ($imgToPreload && $imgToPreload.length) {
            loadImg($imgToPreload);
        }
    }
}

export function preloadSlideNegativeIndex($slider, slick, slideIndex) {
    let slideToPreload = $slider.find(`[data-slick-index='${slideIndex}']`);

    if (slideToPreload) {
        let $imgToPreload = $(slideToPreload).find('.js-lazy-img');
        if ($imgToPreload && $imgToPreload.length) {
            loadImg($imgToPreload);
        }
    }
}